// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"edc00987","464":"e7e0a344"}[chunkId] + ".chunk.css";
};